import React from 'react'
import { Button } from '../Button/Button'
import { Modal } from '../Modal/Modal'

type FileDisplayModalProps = {
  fileUrl: string
  show: boolean
  onHide: () => void
  type: 'audio' | 'image'
}

const FileDisplayContent: React.FC<{ type: 'audio' | 'image'; fileUrl: string }> = ({ type, fileUrl }) => {
  switch (type) {
    case 'image':
      return (
        <div className='text-center p-4'>
          <img className='img-fluid' alt='' src={fileUrl} />
        </div>
      )
    case 'audio':
      return (
        <div className='text-center p-4'>
          <audio controls>
            <source src={fileUrl} />
            Your browser does not support the audio element.
          </audio>
        </div>
      )
    default:
      return null
  }
}

export const FileDisplayModal: React.FC<FileDisplayModalProps> = ({ show, onHide, fileUrl, type }) => {
  const modalFooter = (
    <div className='d-flex gap-3'>
      <Button variant='secondary' onClick={onHide}>
        Close
      </Button>
    </div>
  )

  return (
    <Modal
      size={type === 'image' ? 'lg' : undefined}
      show={show}
      onHide={onHide}
      body={<FileDisplayContent type={type} fileUrl={fileUrl} />}
      showFooterActions={false}
      footer={modalFooter}
      centered={true}
    />
  )
}
